import { StandardEvents, ProductSelectEvent } from '@shopify/events';
import { Component } from '@theme/component';
import { DialogCloseEvent, DialogOpenEvent, DialogComponent } from '@theme/dialog';

class ProductLosAngeles extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    
    const dialogComponent = this.querySelector('.dialog-component-product-slideshow');
    if (!dialogComponent) return;
    dialogComponent.addEventListener(DialogOpenEvent.eventName, this.#handleDialogOpen);
    dialogComponent.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    
    const dialogComponent = this.querySelector('.dialog-component-product-slideshow');
    if (!dialogComponent) return;
    dialogComponent.removeEventListener(DialogOpenEvent.eventName, this.#handleDialogOpen);
    dialogComponent.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  #handleDialogOpen = (event) => {
    const mainSlideshow = this.querySelector('slideshow-component[ref="slideshow"]');
    const dialogSlideshow = this.querySelector('slideshow-component[ref="dialogSlideshow"]');
    if (!mainSlideshow || !dialogSlideshow) return;

    const mainSlides = [...mainSlideshow.querySelectorAll('slideshow-slide')];
    const activeSlide = mainSlides.find(
      slide => slide.getAttribute('aria-hidden') === 'false'
    );
    if (!activeSlide) return;
    
    const index = mainSlides.indexOf(activeSlide);
    dialogSlideshow.select(index);
  }

  #handleDialogClose = (event) => {
    const mainSlideshow = this.querySelector('slideshow-component[ref="slideshow"]');
    const dialogSlideshow = this.querySelector('slideshow-component[ref="dialogSlideshow"]');
    if (!mainSlideshow || !dialogSlideshow) return;

    const dialogSlides = [...dialogSlideshow.querySelectorAll('slideshow-slide')];
    const activeSlide = dialogSlides.find(
      slide => slide.getAttribute('aria-hidden') === 'false'
    );
    if (!activeSlide) return;
    
    const index = dialogSlides.indexOf(activeSlide);
    mainSlideshow.select(index);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element)) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        // update price container
        const currentPrice = document.querySelector('.price-container');
        const newPrice = detail.html.querySelector('.price-container');
        if (currentPrice && newPrice)
          currentPrice.replaceWith(newPrice);

        // update shipping status
        const currentStatus =
          document.querySelector('.in-stock-container') ||
          document.querySelector('.shipping-information-container');

        const newStatus =
          detail.html.querySelector('.in-stock-container') ||
          detail.html.querySelector('.shipping-information-container');

        if (currentStatus && newStatus) {
          currentStatus.replaceWith(newStatus);
        }

        // update two media gallery
        const currentGallery = document.querySelector('two-view-media-gallery');
        const newGallery = detail.html.querySelector('two-view-media-gallery');
        if (currentGallery && newGallery)
          currentGallery.replaceWith(newGallery);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-price] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-los-angeles')) {
  customElements.define('product-los-angeles', ProductLosAngeles);
}